module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ExtraLightItalic-d847e832d8c10db6357e4b3ca0de0b06.woff2";